<template>
  <div class="invite-gift-page">
    <div class="header">
      <h1>邀请好友，可获得<span class="highlight">10000点数</span></h1>
      <p>多邀多得，奖励无上限！</p>
      <img src="@/apps/portal/assets/invite-banner.png" class="banner-img" />
      <el-button type="primary" size="large" class="invite-btn" @click="handleInviteClick">立即邀请</el-button>
    </div>
    <el-dialog
      v-model="showInviteDialog"
      width="520px"
      :show-close="true"
      center
      class="invite-dialog"
      :close-on-click-modal="false"
    >
      <div class="invite-dialog-content">
        <div class="invite-banner-row">
          <img src="@/apps/portal/assets/invite-banner.png" class="invite-dialog-banner" />
          <div class="invite-dialog-text">
            <div>复制链接给好友，好友注册后，双方即可获得奖励</div>
            <div class="invite-dialog-code">您的邀请码：{{ userStore.userInfo?.qrCode }}</div>
          </div>
        </div>
        <div class="invite-link-row">
          <span class="invite-link">{{ inviteLink }}</span>
          <el-button type="primary" size="default" class="copy-btn" @click="copyInviteLink">复制链接</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="reward-section">
      <h3>邀请人奖励</h3>
      <el-table :data="rewardData1" border style="width: 100%">
        <el-table-column prop="type" label="邀请方式/可得奖励" />
        <el-table-column prop="max" label="活动奖励" />
      </el-table>
      <h3>被邀请人奖励</h3>
      <el-table :data="rewardData2" border style="width: 100%">
        <el-table-column prop="type" label="邀请方式/可得奖励" />
        <el-table-column prop="max" label="活动奖励" />
      </el-table>
      <div class="desc">
        <h3>活动规则说明</h3>
        <ol>
          <li>邀请对象：仅限非当前会员的用户。</li>
          <li>奖励发放：奖励将在好友成功注册和充值后发放。</li>
          <li>奖励无上限，邀请越多奖励越多。</li>
          <li>如有作弊行为，将取消奖励资格。</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/portal/user'
import { useRouter } from 'vue-router'

const showInviteDialog = ref(false)
const userStore = useUserStore()
const router = useRouter()

// 检查登录状态
const isLoggedIn = computed(() => {
  return !!localStorage.getItem('token')
})

// 生成邀请码链接
const inviteLink = computed(() => {
  const code = userStore.userInfo?.qrCode || ''
  return `${window.location.origin}/register?inviteCode=${code}`
})

// 处理立即邀请按钮点击
const handleInviteClick = () => {
  if (!isLoggedIn.value) {
    ElMessage.warning('请先登录后再使用邀请功能')
    router.push('/login')
    return
  }
  showInviteDialog.value = true
}

const copyInviteLink = async () => {
  try {
     await navigator.clipboard.writeText(inviteLink.value)
    ElMessage.success('邀请链接已复制！')
  } catch (e) {
    ElMessage.error('复制失败，请手动复制')
  }
}

const rewardData1 = [
  { type: '注册', max: '10000点数' },
  { type: '充值', max: '额外赠送点数（详情查看充值页面）' }
]

const rewardData2 = [
  { type: '注册', max: '10000点数' },
  { type: '被邀请人充值（30w点数或以上），邀请人可获奖励',  max: '5000点数' }
]
</script>

<style scoped>
.invite-gift-page {
  background: #232326;
  padding: 32px 16px;
  min-height: 100vh;
  height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
  color: #fff;
}
.header {
  text-align: center;
  margin-bottom: 32px;
}
.header h1, .header p {
  color: #fff;
}
.highlight {
  color: #00c1cd;
  font-weight: bold;
}
.banner-img {
  width: 320px;
  margin: 16px auto;
  display: block;
  border-radius: 12px;
  box-shadow: 0 2px 12px #0002;
}
.invite-btn {
  margin-top: 16px;
  border-radius: 8px;
}
.reward-section {
  max-width: 800px;
  margin: 0 auto;
  background: #262626;
  border-radius: 16px;
  box-shadow: 0 2px 12px #0003;
  padding: 24px 16px;
  color: #fff;
}
.reward-section h3 {
  color: #00c1cd;
  margin-top: 18px;
}
.el-table {
  background: #232326;
  color: #fff;
  border-radius: 8px;
  margin-bottom: 18px;
}
.el-table th, .el-table td {
  background: #232326 !important;
  color: #fff !important;
}
.desc {
  margin-top: 24px;
  color: #ccc;
}
.invite-dialog-content {
  padding: 0 0 8px 0;
  color: #fff;
}
.invite-banner-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.invite-dialog-banner {
  width: 110px;
  border-radius: 8px;
  background: #fff;
}
.invite-dialog-text {
  flex: 1;
  font-size: 15px;
  color: #fff;
}
.invite-dialog-reward {
  margin-top: 8px;
}
.reward-badge {
  display: inline-block;
  background: #232326;
  color: #00c1cd;
  border-radius: 16px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #00c1cd;
}
.invite-dialog-code {
  margin-top: 8px;
  font-size: 14px;
  color: #00c1cd;
}
.invite-link-row {
  display: flex;
  align-items: center;
  background: #232326;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 8px;
  gap: 8px;
  word-break: break-all;
  color: #fff;
  border: 1px solid #333;
}
.invite-link {
  flex: 1;
  font-size: 14px;
  color: #fff;
}
.copy-btn {
  margin-left: 8px;
  border-radius: 6px;
}
.el-dialog.invite-dialog {
  border-radius: 16px;
  background: #232326;
  color: #fff;
}
.el-dialog__body {
  background: #232326;
  color: #fff;
}
@media (max-width: 700px) {
  .banner-img {
    width: 90vw;
    max-width: 320px;
  }
  .invite-gift-page {
    padding: 16px 4px;
  }
}
</style>
